import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { UsageRow } from '../utils/densify';
import { Box } from '@mui/material';

type Props = { data: UsageRow[] };

export function UsageChart({ data }: Props) {
  return (
    <Box sx={{ width: '100%', height: 220 }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 16, right: 0, left: -28, bottom: 0 }}>
          <XAxis
            dataKey="date"
            tickFormatter={(d) => d.slice(8, 10)}
            tick={{ fontFamily: 'IBM Plex Mono', fontSize: 11, fill: 'var(--ink-muted)' }}
            axisLine={{ stroke: 'var(--rule)' }}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontFamily: 'IBM Plex Mono', fontSize: 11, fill: 'var(--ink-muted)' }}
            axisLine={false}
            tickLine={false}
            width={40}
          />
          <Tooltip
            cursor={{ fill: 'var(--rule)', opacity: 0.4 }}
            contentStyle={{
              backgroundColor: 'var(--bg-elevated)',
              border: '1px solid var(--rule)',
              borderRadius: 0,
              fontFamily: 'IBM Plex Mono',
              fontSize: '0.75rem',
            }}
            labelStyle={{ color: 'var(--ink)' }}
            formatter={(v: number) => [`${v} call${v === 1 ? '' : 's'}`, '']}
          />
          <Bar dataKey="count" radius={0} animationDuration={600}>
            {data.map((d) => (
              <Cell key={d.date} fill={d.count > 0 ? 'var(--accent)' : 'var(--rule)'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
